<template>
    <div class="modal">
        <div class="popup">
            <svg width="147px" height="147px" viewBox="0 0 147 147">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-230.000000, -416.000000)" fill="#52BD8A" fill-rule="nonzero">
                        <g transform="translate(64.000000, 368.000000)">
                            <g transform="translate(73.000000, 48.000000)">
                                <path d="M237,73.5 C237,112.436252 205.43246,144 166.5,144 C127.555305,144 96,112.442799 96,73.5 C96,34.5572009 127.555305,3 166.5,3 C205.43246,3 237,34.5637483 237,73.5 L237,73.5 L237,73.5 Z M240,73.5 C240,32.9068134 207.089233,0 166.5,0 C125.898411,0 93,32.900387 93,73.5 C93,114.099613 125.898411,147 166.5,147 C207.089233,147 240,114.093187 240,73.5 L240,73.5 L240,73.5 Z M197.477765,50.4022589 L150.227765,94.4022589 L152.309456,94.4381366 L136.559456,78.7238509 C135.973005,78.1387297 135.023258,78.1398078 134.438137,78.7262587 C133.853015,79.3127097 133.854093,80.2624566 134.440544,80.8475777 L150.190544,96.5618634 C150.761819,97.1318423 151.681659,97.1476956 152.272235,96.5977411 L199.522235,52.5977411 C200.128501,52.0331762 200.162306,51.0840306 199.597741,50.4777649 C199.033176,49.8714993 198.084031,49.8376941 197.477765,50.4022589 L197.477765,50.4022589 L197.477765,50.4022589 Z"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <div class="popup-title">Поздравляем!<br />Ваше сообщение успешно отправлено.</div>
            <div class="popup-text">
                <button class="btn-action"
                        @click="$emit('close')">Понятно</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "sent"
    }
</script>